import banner from './banner.svg';
import styled from '@emotion/styled';
import { fromZonedTime } from 'date-fns-tz';
import { getGameJamConfig } from '@crazygames/gamejam/game-jam-config';

const gameJamConfig = getGameJamConfig('202509_gamemaker');
const gameJamLink = gameJamConfig?.link;

export function shouldShowGameJamBanner() {
  if (window.location.href.includes('http://localhost:3001')) {
    return true;
  }

  const currentTime = new Date();

  // Start date: Monday 1/9, 10:00 AM CET
  const startDate = fromZonedTime('2025-09-01T10:00:00Z', 'CET');

  // End date: 21/9, 23:59 PM CET
  const endDate = fromZonedTime('2025-09-21T23:59:59Z', 'CET');

  return currentTime >= startDate && currentTime <= endDate;
}

const StyledGameJamBanner = styled('div')({
  '@media (max-width: 1100px)': {
    display: 'none',
  },
  height: `100px`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
});

export const GameJamBanner: React.FC = () => {
  return (
    <a href={gameJamLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
      <StyledGameJamBanner>
        <img className="banner" src={banner} />
      </StyledGameJamBanner>
    </a>
  );
};
